module.exports = __webpack_public_path__ + "img/1F605.61decfd1.svg";